import React,{useState,useEffect} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
//import IconButton from '@mui/material/IconButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Owner,Book} from './Inc';
import Ajax from './Ajax';

interface Props {
    owner:Owner,
    book:Book,
}

const BookPreview = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);
    const [status,setStatus] = useState(0);
    const download = ()=>{
        Ajax.download("book/download",{item_id:props.book.item_id,filename:props.book.book_name},(res:any)=>{
            if( res.ok ){
                
            } else {

            }
        });
    }
    useEffect( ()=>{
        //console.log("item_id",props.item_id);
        Ajax.send("book/pdf",{item_id:props.book.item_id},(res:any)=>{
            if( res.ok ){
                setStatus(1);
            } else {
                setStatus(9);
            }
        })
    },[])
    return (
        <div id="book_preview" className="bookPreview">
            {status===1 &&
            <div className="preview preview_ready">
                <div onClick={download} style={{cursor:"pointer"}}><FontAwesomeIcon icon="file-download" style={{fontSize:"200%"}}/><br/>ダウンロードできます</div>
            </div>
            }
            {status===0 &&
            <div className="preview preview_waiting">
                <CircularProgress/><br/>プレビュー作成中
            </div>
            }
            {status===9 &&
            <div className="preview preview_error">
                <CircularProgress/><br/>作成できませんでした
            </div>
            }
        </div>
	);
}

export default BookPreview;
